VjsAdmin.SalesMap = (function () {
    let map;
    let divMap;
    let state;

    /* STATE LATS */
    const stateLat = {
        AK: 61.385,
        AL: 32.799,
        AR: 34.9513,
        AS: 14.2417,
        AZ: 33.7712,
        CA: 36.17,
        CO: 39.0646,
        CT: 41.5834,
        DC: 38.8964,
        DE: 39.3498,
        FL: 27.8333,
        GA: 32.9866,
        HI: 21.1098,
        IA: 42.0046,
        ID: 44.2394,
        IL: 40.3363,
        IN: 39.8647,
        KS: 38.5111,
        KY: 37.669,
        LA: 31.1801,
        MA: 42.2373,
        MD: 39.0724,
        ME: 44.6074,
        MI: 43.3504,
        MN: 45.7326,
        MO: 38.4623,
        MP: 14.8058,
        MS: 32.7673,
        MT: 46.9048,
        NC: 35.6411,
        ND: 47.5362,
        NE: 41.1289,
        NH: 43.4108,
        NJ: 40.314,
        NM: 34.8375,
        NV: 38.4199,
        NY: 42.1497,
        OH: 40.3736,
        OK: 35.5376,
        OR: 44.5672,
        PA: 40.5773,
        PR: 18.2766,
        RI: 41.6772,
        SC: 33.8191,
        SD: 44.2853,
        TN: 35.7449,
        TX: 31.106,
        UT: 40.1135,
        VA: 37.768,
        VI: 18.0001,
        VT: 44.0407,
        WA: 47.3917,
        WI: 44.2563,
        WV: 38.468,
        WY: 42.7475,
    };

    /* STATE LON */
    const stateLon = {
        AK: -152.2683,
        AL: -86.8073,
        AR: -92.3809,
        AS: -170.7197,
        AZ: -111.3877,
        CA: -119.7462,
        CO: -105.3272,
        CT: -72.7622,
        DC: -77.0262,
        DE: -75.5148,
        FL: -81.717,
        GA: -83.6487,
        HI: -157.5311,
        IA: -93.214,
        ID: -114.5103,
        IL: -89.0022,
        IN: -86.2604,
        KS: -96.8005,
        KY: -84.6514,
        LA: -91.8749,
        MA: -71.5314,
        MD: -76.7902,
        ME: -69.3977,
        MI: -84.5603,
        MN: -93.9196,
        MO: -92.302,
        MP: 145.5505,
        MS: -89.6812,
        MT: -110.3261,
        NC: -79.8431,
        ND: -99.793,
        NE: -98.2883,
        NH: -71.5653,
        NJ: -74.5089,
        NM: -106.2371,
        NV: -117.1219,
        NY: -74.9384,
        OH: -82.7755,
        OK: -96.9247,
        OR: -122.1269,
        PA: -77.264,
        PR: -66.335,
        RI: -71.5101,
        SC: -80.9066,
        SD: -99.4632,
        TN: -86.7489,
        TX: -97.6475,
        UT: -111.8535,
        VA: -78.2057,
        VI: -64.8199,
        VT: -72.7093,
        WA: -121.5708,
        WI: -89.6385,
        WV: -80.9696,
        WY: -107.2085,
    };

    let markers = [];
    let markerCluster = null;

    const init = function () {
        divMap = document.getElementById('map');
        initMap();

        $('#new-search').on('click', () => {
            loadData();
        });
        dragMenu(document.getElementById('mapmenu'));
    };

    /*
     *
     */
    function initMap() {
        // Set Main Map Options
        const mapOptions = {
            center: new google.maps.LatLng(39.8282, -98.5795), // Center US
            zoom: 4,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
        };

        // Draws Map
        map = new google.maps.Map(divMap, mapOptions);
    }

    function drawMap(Json) {
        if (Json !== undefined) {
            let districtMarkers;
            if (Json.type === 'Districts') {
                districtMarkers = Json.data.map(configDistricts);
                // Add a marker clusterer to manage the markers.
                markerCluster = new MarkerClusterer(map, districtMarkers, {
                    imagePath: '/assets/images/salesmap/cluster-icons/m',
                    gridSize: 75,
                    maxZoom: 7,
                });
            } else {
                markers = Json.data.map(configLicenses);
            }

            Array.prototype.push.apply(markers, districtMarkers);
        }
    }

    function resetMap() {
        // Loop through all the markers and remove
        for (let i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }
        markers = [];
        if (markerCluster) {
            markerCluster.clearMarkers();
        }

        const lat = state === '' ? 39.8282 : stateLat[state];
        const lon = state === '' ? -98.5795 : stateLon[state];
        const z = state === '' ? 4 : 7;
        map.setCenter({ lat, lng: lon });
        map.setZoom(z);
    }

    function loadData() {
        $('#ajax-progress-indicator').fadeIn();
        // Set global
        state = $('#state').val();

        // set Map conditions
        const mapConditions = {};
        mapConditions.state = state === '' ? '' : state;
        mapConditions.sizeSmall = $('#small-district').is(':checked') ? 1 : 0;
        mapConditions.sizeMedium = $('#medium-district').is(':checked') ? 1 : 0;
        mapConditions.sizeLarge = $('#large-district').is(':checked') ? 1 : 0;
        mapConditions.sizeXlarge = $('#very-large-district').is(':checked') ? 1 : 0;
        mapConditions.vjsjr = $('#VJSJr').is(':checked') ? 1 : 0;
        mapConditions.vjscollege = $('#VJSCollege').is(':checked') ? 1 : 0;
        mapConditions.vjsschool = $('#VJSSchool').is(':checked') ? 1 : 0;

        resetMap();

        $.when(getDistricts(mapConditions), getVJSLicenses(mapConditions), getVJSJrLicenses(mapConditions)).then(
            (districts, vjslicenses, vjsjrlicenses) => {
                if (districts !== undefined) {
                    districts[0].type = 'Districts';
                    drawMap(districts[0]);
                }
                if (vjslicenses !== undefined) {
                    vjslicenses[0].type = 'VJSLicenses';
                    drawMap(vjslicenses[0]);
                }
                if (vjsjrlicenses !== undefined) {
                    vjsjrlicenses[0].type = 'VJSJrLicenses';
                    drawMap(vjsjrlicenses[0]);
                }
                $('#ajax-progress-indicator').fadeOut();
            },
            () => {
                console.log('ERROR!');
            },
        );
    }

    function getDistricts(mapConditions) {
        if (mapConditions.sizeSmall || mapConditions.sizeMedium || mapConditions.sizeLarge || mapConditions.sizeXlarge) {
            // if asking for districts
            return $.ajax({
                url: Slim.Router.pathFor('districts.list.map.json', { platform_id: 1 }, mapConditions),
                dataType: 'json',
                method: 'POST',
                async: true,
            });
        }
    }

    function getVJSLicenses(mapConditions) {
        if (mapConditions.vjscollege || mapConditions.vjsschool) {
            return $.ajax({
                url: Slim.Router.pathFor('sales.map.list.vjslicenses.json', { platform_id: 1 }, mapConditions),
                dataType: 'json',
                method: 'POST',
                async: true,
            });
        }
    }

    function getVJSJrLicenses(mapConditions) {
        if (mapConditions.vjsjr) {
            return $.ajax({
                url: Slim.Router.pathFor('sales.map.list.vjsjrlicenses.json', { platform_id: 2 }, mapConditions),
                dataType: 'json',
                method: 'POST',
                async: true,
            });
        }
    }

    function configDistricts(point) {
        const latLng = new google.maps.LatLng(point.lat, point.lon);

        const marker = new google.maps.Marker({
            position: latLng,
            title: point.agencyName,
            icon: `/assets/images/salesmap/icons/${point.icon}.png`,
        });

        let contentHtml = `<h1 style='font-size: 1.4em; color: #3399cc; margin-bottom: 0;'>${point.agencyName}</h1>`;
        contentHtml += `<p style='margin: 0 0 0 0; font-size: 1.0em;'>${point.address}<br />${point.city} ${point.state}, ${point.zip}</p>`;
        contentHtml += `<p style='margin: 0; font-size: 1.0em; color: #666;font-weight: bold;'>${prepPhone(point.phone)}</p>`;
        contentHtml += `<p style='margin-bottom: 0; font-weight: bold; font-size: 1.2em; color: #222;'>Schools: ${point.schoolCount}</p>`;
        contentHtml += `<p style='margin-top: 0; font-weight: bold; color: #222; font-size: 1.2em;'>Students: ${point.studentCount}</p>`;

        const infoWindow = new google.maps.InfoWindow({
            content: contentHtml,
        });
        // Attaching a click event to the current marker
        google.maps.event.addListener(marker, 'click', () => {
            infoWindow.open(map, marker);
        });

        return marker;
    }

    function configLicenses(point) {
        const latLng = new google.maps.LatLng(point.lat, point.lon);
        const marker = new google.maps.Marker({
            position: latLng,
            map,
            title: point.license_name,
            icon: `/assets/images/salesmap/icons/${point.type}.png`,
        });

        const linkToLicense = Slim.Router.pathFor('platforms.districts.licenses.view', {
            platform_id: point.platform_id,
            district_joint_guid: point.district_joint_guid,
            license_id: point.LicenseID,
        });
        const linkToDistrict = Slim.Router.pathFor('platforms.districts.view', {
            platform_id: point.platform_id,
            district_joint_guid: point.district_joint_guid,
        });
        let contentHtml = `<h1 style='font-size: 1.4em; color: #3399cc; margin-bottom: 0;'><a href='${linkToLicense}' target='_blank'>${point.OrgName}</a></h1>`;
        contentHtml += `<a href='${linkToDistrict}' target='_blank'><p style='margin: 0; font-size: 1.0em; color: #666 !important;font-weight: bold;'>${point.district_name}</p></a>`;
        contentHtml += `<p style='margin: 0 0 0 0; font-size: 1.0em;'>${point.City}, ${point.State}</p>`;

        const infoWindow = new google.maps.InfoWindow({
            content: contentHtml,
        });
        // Attaching a click event to the current marker
        google.maps.event.addListener(marker, 'click', () => {
            if (isInfoWindowOpen(infoWindow)) {
                infoWindow.close();
            } else {
                infoWindow.open(map, marker);
            }
        });

        return marker;
    }

    /*
     * PREP PHONE
     */
    function prepPhone(item) {
        if (item.length === 11) {
            return item.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1 ($2) $3-$4');
        }
        if (item.length === 10) {
            return item.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        }
    }

    /**
     * Menu draggable
     */
    function dragMenu(elmnt) {
        let pos1 = 0;
        let pos2 = 0;
        let pos3 = 0;
        let pos4 = 0;
        document.getElementById(`${elmnt.id}Move`).onmousedown = dragMouseDown;

        function dragMouseDown(e) {
            const event = e || window.event;
            event.preventDefault();
            // get the mouse cursor position at startup:
            pos3 = e.clientX;
            pos4 = e.clientY;
            document.onmouseup = closeDragMenu;
            // call a function whenever the cursor moves:
            document.onmousemove = elementDrag;
        }

        function elementDrag(e) {
            const event = e || window.event;
            event.preventDefault();
            // calculate the new cursor position:
            pos1 = pos3 - e.clientX;
            pos2 = pos4 - e.clientY;
            pos3 = e.clientX;
            pos4 = e.clientY;
            // set the element's new position:
            elmnt.style.top = `${elmnt.offsetTop - pos2}px`;
            elmnt.style.left = `${elmnt.offsetLeft - pos1}px`;
        }

        function closeDragMenu() {
            // stop moving when mouse button is released:
            document.onmouseup = null;
            document.onmousemove = null;
        }
    }

    function isInfoWindowOpen(infoWindow) {
        const window = infoWindow.getMap();
        return window !== null && typeof window !== 'undefined';
    }

    return {
        init,
    };
}());
